module.exports = __webpack_public_path__ + "static/media/anta.dc613039.mp3";